import {APP_NO_IMG} from "../const/root";

export interface ProductImages {
    small: string[];
    big: string[];
    tone: string[];
}

export class HelperImage {
    static withCacheBust(url: string, version?: string | number | null): string {
        if (!url || url === APP_NO_IMG || url.startsWith('/img/')) {
            return url || APP_NO_IMG;
        }
        if (version == null || version === '') {
            return url;
        }

        const v = encodeURIComponent(String(version));
        if (/[?&]v=/.test(url)) {
            return url.replace(/([?&])v=[^&]*/, `$1v=${v}`);
        }

        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}v=${v}`;
    }

    static getProductImageCacheKey(product: any): string | null {
        if (!product) {
            return null;
        }

        const imageUpdatedAt = product.propsNoFilter?.imageUpdatedAt;
        if (!imageUpdatedAt) {
            return null;
        }

        const version = String(imageUpdatedAt);
        const pictures = product.propsNoFilter?.pictures;

        if (Array.isArray(pictures) && pictures.length) {
            return `${pictures.join('|')}_${version}`;
        }

        return version;
    }

    static getProductImageSrc(product: any, index = 0, size: 'small' | 'big' | 'tone' = 'small'): string {
        const img = product?.img;
        const urls = img?.[size];
        const url = urls?.[index];

        if (!url) {
            return APP_NO_IMG;
        }

        return this.withCacheBust(url, this.getProductImageCacheKey(product));
    }

    static mapProductImages(img: any, cacheKey: string | null): ProductImages {
        const bust = (url: string) => this.withCacheBust(url, cacheKey);

        return {
            small: (img?.small || []).map(bust),
            big: (img?.big || []).map(bust),
            tone: (img?.tone || []).map(bust),
        };
    }
}
